import { ConciergeBehaviorSettingsParser } from "@redotech/redo-model/concierge-settings/general";
import { object, string } from "zod";
import { UrlArraySchema } from "../common/url-parser";

export const generateConciergeBehavior = {
  input: object({ text: string().max(100000), urls: UrlArraySchema }),
  output: ConciergeBehaviorSettingsParser,
};
